import React, { useState, useEffect } from 'react';

// components
import { Row, Col, Card, CardBody, CardHeader, Button } from "reactstrap";

// Views
import Identificacao from "./BoletimVistoriaComponents/Identificacao";
import BoletinsVinculados from './BoletimVistoriaComponents/BoletinsVinculados';
import Cabecalho from "./BoletimVistoriaComponents/Cabecalho";
import Inspecoes from "./BoletimVistoriaComponents/Inspecoes";
import AnaliseGestor from './AnaliseBoletimVistoriaComponents/AnaliseGestor';
import DefesaPrevia from './AnaliseBoletimVistoriaComponents/DefesaPrevia';
import AnaliseDefesaPrevia from './AnaliseBoletimVistoriaComponents/AnaliseDefesaPrevia';
import RecursoJuridico from './AnaliseBoletimVistoriaComponents/RecursoJuridico';
import AnaliseRecursoJuridico from './AnaliseBoletimVistoriaComponents/AnaliseRecursoJuridico';
import PublicacaoDiarioOficial from './AnaliseBoletimVistoriaComponents/PublicacaoDiarioOficial';
import HistoricoAnalise from './BoletimVistoriaComponents/HistoricoAnalise';
import PenalidadesAplicadas from './BoletimVistoriaComponents/PenalidadesAplicadas';
import AnaliseInconformidades from './AnaliseBoletimVistoriaComponents/AnaliseInconformidades';
import PedidoVista from "./AnaliseBoletimVistoriaComponents/PedidoVista";
import AguardandoAnalise from "./AnaliseBoletimVistoriaComponents/AguardadoAnalise";

// helpers
import { showMessage, showQuestion } from "../../helpers/message";

// api
import usuario_api from "../../api/usuario_api.js";
import boletimvistoria_api from "../../api/boletimvistoria_api.js";

export default function VistoriaFicha({ boletimVistoria, setshowLoading, handleReturn }) {

    const [acao, set_acao] = useState(null);

    const [boletimVistoriaItem, setBoletimVistoriaItem] = useState(boletimVistoria);

    const [showExcluirBoletim, set_showExcluirBoletim] = useState(false);

    //permitir usuario editar formulario
    const [permitirEditarBoletim, setPermitirEditarBoletim] = useState(false);
    
    // atualizar o componente para pegar qualquer tipo de mudança no boletim, na etapa de "Aguardando Análise"
    useEffect(() => {
        if(boletimVistoriaItem.situacaoAnalise === "Aguardando Análise"){
            set_acao(<AguardandoAnalise
                boletimVistoria={boletimVistoriaItem}
                setshowLoading={setshowLoading}
                handleReturn={handleReturn}
            />)
        }
    }, [boletimVistoriaItem]);

    useEffect(() => {
        loadAcoesExecucao();

        if (boletimVistoriaItem.situacaoAnalise === "Penalidades Apontadas" || boletimVistoriaItem.situacaoAnalise === "Finalizado sem Inconformidades")
            usuario_api.getFuncionalidadeAcaoLiberada("ConsultaVistoria", "Excluir Boletim").then((result) => { set_showExcluirBoletim(result); });
        if (boletimVistoriaItem.situacaoAnalise === "Aguardando Análise")
            usuario_api.getFuncionalidadeAcaoLiberada("FichaBoletimVistoria", "Editar Resposta Boletim").then((result) => { setPermitirEditarBoletim(result) });
    }, []);


    const loadAcoesExecucao = () => {
        const permissaoLiberada = (permissao, component) => {
            usuario_api.getFuncionalidadeAcaoLiberada("FichaBoletimVistoria", permissao).then((result) => {
                if (result) {
                    set_acao(component);
                }
            });
        }

        switch (boletimVistoriaItem.situacaoAnalise) {
            case "Em Análise de Inconformidades":
                return permissaoLiberada("Análise de Inconformidades",
                    <AnaliseInconformidades
                        boletimVistoria={boletimVistoriaItem}
                        setshowLoading={setshowLoading}
                        handleReturn={handleReturn}
                    />);
            case "Penalidades Apontadas":
                return permissaoLiberada("Efetuar Enquadramento",
                    <AnaliseGestor
                        boletimVistoria={boletimVistoriaItem}
                        setshowLoading={setshowLoading}
                        handleReturn={handleReturn}
                    />);
            case "Aguardando Defesa":
                return permissaoLiberada("Efetuar Defesa",
                    <DefesaPrevia
                        boletimVistoria={boletimVistoriaItem}
                        setshowLoading={setshowLoading}
                        handleReturn={handleReturn}
                    />);
            case "Em Análise de Defesa":
                return permissaoLiberada("Analisar Defesa", <AnaliseDefesaPrevia
                    boletimVistoria={boletimVistoriaItem}
                    setshowLoading={setshowLoading}
                    handleReturn={handleReturn}
                />);
            case "Aguardando Publicação":
                return permissaoLiberada("Publicar Diário Oficial",
                    <PublicacaoDiarioOficial
                        boletimVistoria={boletimVistoriaItem}
                        setshowLoading={setshowLoading}
                        handleReturn={handleReturn}
                    />);
            case "Defesa Reprovada e Multado":
            case "Defesa Reprovada e Advertido":
                return permissaoLiberada("Efetuar Recurso",
                    <RecursoJuridico
                        boletimVistoria={boletimVistoriaItem}
                        setshowLoading={setshowLoading}
                        handleReturn={handleReturn}
                    />);
            case "Em Análise de Recurso":
                return permissaoLiberada("Finalizar Processo",
                    <AnaliseRecursoJuridico
                        boletimVistoria={boletimVistoriaItem}
                        setshowLoading={setshowLoading}
                        handleReturn={handleReturn}
                    />);
            case "Aguardando Análise":
                return permissaoLiberada("Editar Resposta Boletim",
                    <AguardandoAnalise
                        boletimVistoria={boletimVistoriaItem}
                        setshowLoading={setshowLoading}
                        handleReturn={handleReturn}
                    />);
        }
    }

    const loadPedidoVista = () => {
        if (boletimVistoriaItem.situacaoAnalise == "Defesa Reprovada e Multado"
            || boletimVistoriaItem.situacaoAnalise == "Defesa Reprovada e Advertido"
            || boletimVistoriaItem.situacaoAnalise == "Em Análise de Recurso")
            return <PedidoVista
                boletimVistoria={boletimVistoriaItem}
                setshowLoading={setshowLoading}
                handleReturn={handleReturn}
            />
    }

    const handleExcluirBoletim = () => {
        showQuestion("Atenção", "Tem certeza que quer excluir o registro?", "question", function (success) {
            if (success) {
                setshowLoading(true);
                boletimvistoria_api.delete(boletimVistoriaItem.boletimVistoria_Id).then(result => {
                    setshowLoading(false);
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
                    }
                });
            }
        });
    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="6">
                        <Button color="default" onClick={() => handleReturn(false)}>
                            <i className="fas fa-chevron-left"></i>  Voltar
                        </Button>
                    </Col>
                    <Col md="6" className="text-right">
                        <Button color="danger" onClick={() => window.open("/empty/impressaovistoria?codigo=" + boletimVistoriaItem.boletimVistoria_Id, "blank")}>
                            <i className="fas fa-file-pdf"></i> Extrair PDF
                        </Button>
                    </Col>
                </Row>
                <Card>
                    <CardHeader>
                        <h4 className="titleCard font-weight-bold text-center">{boletimVistoriaItem.formularioVistoria_Identificacao}</h4>
                    </CardHeader>
                    <CardBody>
                        <Identificacao
                            boletimVistoria={boletimVistoriaItem}
                        />
                        {boletimVistoriaItem.boletimVistoriaVinculos.length > 0 &&
                            <BoletinsVinculados
                                boletimVistoriaVinculos={boletimVistoriaItem.boletimVistoriaVinculos}
                            />
                        }
                        <Cabecalho
                            boletimVistoria={boletimVistoriaItem}
                        />
                        <Inspecoes
                            boletimVistoria={boletimVistoriaItem}
                            permitirEditarBoletim={permitirEditarBoletim}
                            setBoletimVistoria={setBoletimVistoriaItem}
                        />
                        {boletimVistoriaItem.boletimVistoriaPenalidades.length > 0 &&
                            <PenalidadesAplicadas
                                penalidades={boletimVistoriaItem.boletimVistoriaPenalidades}
                            />
                        }
                        {boletimVistoriaItem.boletimVistoriaHistoricoAnalise.length > 0 &&
                            <HistoricoAnalise
                                historico={boletimVistoriaItem.boletimVistoriaHistoricoAnalise}
                            />

                        }
                        {loadPedidoVista()}
                        {acao}
                        {showExcluirBoletim &&
                            <Row>
                                <Col lg="12" md="12" sm="12" className="text-right">
                                    <Button color="danger" onClick={handleExcluirBoletim}>
                                        Excluir Boletim
                                    </Button>
                                </Col>
                            </Row>
                        }
                    </CardBody>
                </Card>
            </div>
        </>
    );
}
